import { Component, inject } from '@angular/core';
import { PrimaryButtonComponent } from '../primary-button/primary-button.component';
import { SecondaryButtonComponent } from '../secondary-button/secondary-button.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatIcon } from '@angular/material/icon';
import { LanguageService } from '../../../core/services/language.service';
import { CourseVariablesService } from '../../../domains/academy/course/services/course-variables.service';
import { CustomPortalError } from '../../../core/errors/models/CustomPortalError';
import { SnackbarService } from '../../../core/services/snackbar.service';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';

@Component({
  selector: 'app-saving-banner',
  imports: [
    TranslocoPipe,
    MatIcon,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
  ],
  templateUrl: './saving-banner.component.html',
})
export class SavingBannerComponent {
  private readonly analyticsService = inject(AnalyticsService);
  private readonly languageService = inject(LanguageService);
  private readonly courseVariablesService = inject(CourseVariablesService);
  private readonly snackbarService = inject(SnackbarService);

  onCancelButtonClicked() {
    this.courseVariablesService.resetVariables();
  }

  saveVariableChanges() {
    this.courseVariablesService.saveVariables().subscribe({
      next: () => {
        this.snackbarService.success(
          'portal.courseSettings.topicAreaSettings.successfulSavedVariablesSnackbar',
        );
        this.analyticsService.track('course_variables_customized');
      },
      error: (error: CustomPortalError) => {
        this.snackbarService.error(error.errorType);
      },
    });
  }

  getNumberofChanges() {
    return this.languageService.translateOnRuntime(
      'portal.courseSettings.topicAreaSettings.saveChangesBanner.unsavedChanges',
      {
        changes:
          this.courseVariablesService.changeCount() === 1
            ? this.languageService.translateOnRuntime(
                'portal.courseSettings.topicAreaSettings.saveChangesBanner.change',
              )
            : this.languageService.translateOnRuntime(
                'portal.courseSettings.topicAreaSettings.saveChangesBanner.changes',
                { n: this.courseVariablesService.changeCount() },
              ),
      },
    );
  }
}
